import { baseUrl } from './url';
// 后台请求地址

let projectApi = 'nfplus-vote-api/'; //接口地址
let imgPath = projectApi + 'file/image?path=';
// 获取当前系统
const sysJuc = {
  ios: /(iPhone|iPad|iPod|iOS)/i,
  android: /(Android)/i,
  wx: /(MicroMessenger)/i,
};
const nav = navigator.userAgent;
const system = sysJuc.wx.test(nav) ? 'wx' : sysJuc.ios.test(nav) ? 'ios' : sysJuc.android.test(nav) ? 'android' : 'other';
const systemIs = sysJuc.ios.test(nav) ? 'ios' : sysJuc.android.test(nav) ? 'android' : 'other';

// 倒计时
const count = (self) => {
  self.valid.state = 3;
  self.valid.value = 60 + 's';
  const countTime = setInterval(() => {
    if (parseInt(self.valid.value) == 0) {
      self.valid.state = 0;
      self.valid.value = '重新获取';
      clearInterval(countTime);
      return;
    }
    self.valid.value = parseInt(self.valid.value) - 1 + 's';
  }, 1000);
};

const validata = {
  num: /^-?\d+(\.\d+)?$/,
  mobile: /^1[34578]\d{9}$/,
  bankCard: /^(\d{16}|\d{19})$/,
  idCard: /(^\d{15}$)|(^\d{17}([0-9]|X)$)/,
  chinese: /^[\u4e00-\u9fa5]+$/,
  bank: /^(\d{16}|\d{19})$/,
  code: /^\d{6}$/,
  regChinese: /^[\u4e00-\u9fa5]+$/,
  money: /^\d{1,8}\.{0,1}(\d{1,2})?$/,
};
// 正则
const checkValidata = (type, data) => {
  let result;
  switch (type) {
    case 'number':
      result = validata.num.test(data);
      break;
    case 'mobile':
      result = validata.mobile.test(data);
      break;
    case 'bankCard':
      result = validata.bankCard.test(data);
      break;
    case 'idCard':
      result = validata.idCard.test(data);
      break;
    case 'chinese':
      result = validata.chinese.test(data);
      break;
    case 'bank':
      result = validata.bank.test(data);
      break;
    case 'code':
      result = validata.code.test(data);
      break;
    case 'chinese':
      result = validata.regChinese.test(data);
      break;
    case 'money':
      result = validata.money.test(data);
      break;
  }
  return result;
};

// 获取当前时间
const getNowData = () => {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  // month=(month<10)?('0'+month):month;
  return {
    year,
    month,
    day,
  };
};

//三位数格式001、002...
const threeNum = (e) => {
  if (typeof e != 'string') {
    e = e.toString();
  }
  if (e.length == 1) {
    e = '00' + e;
  } else if (e.length == 2) {
    e = '0' + e;
  }
  return e;
};

//版本号比较
const compareVersion = (curV, reqV) => {
  var arr1 = curV.split('.');
  var arr2 = reqV.split('.');
  //将两个版本号拆成数字
  var minL = Math.min(arr1.length, arr2.length);
  var pos = 0; //当前比较位
  var diff = 0; //当前为位比较是否相等

  //逐个比较如果当前位相等则继续比较下一位
  while (pos < minL) {
    diff = parseInt(arr1[pos]) - parseInt(arr2[pos]);
    if (diff != 0) {
      break;
    }
    pos++;
  }

  if (diff > 0) {
    //新版本
    return true;
  } else if (diff == 0) {
    //稳定版
    return true;
  } else {
    //旧版本
    return false;
  }
};

const getAllUrlParams = (url) => {
  // 从url(可选)或window对象获取查询字符串
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
  var obj = {};
  if (queryString) {
    // 查询字符串不包含#后面的部分，因此去掉它
    queryString = queryString.split('#')[0];
    var arr = queryString.split('&');
    for (var i = 0; i < arr.length; i++) {
      // 分离出key和value
      var a = arr[i].split('=');
      // 考虑到这样的参数：list[]=thing1&list[]=thing2
      var paramNum = undefined;
      var paramName = a[0].replace(/\[\d*\]/, function (v) {
        paramNum = v.slice(1, -1);
        return '';
      });
      // 设置参数值（如果为空则设置为true）
      var paramValue = typeof a[1] === 'undefined' ? true : a[1];
      // （可选）保持大小写一致
      paramName = paramName.toLowerCase();
      paramValue = paramValue.toLowerCase();
      // 如果参数名已经存在
      if (obj[paramName]) {
        // 将值转成数组（如果还是字符串）
        if (typeof obj[paramName] === 'string') {
          obj[paramName] = [obj[paramName]];
        }
        // 如果没有指定数组索引
        if (typeof paramNum === 'undefined') {
          // 将值放到数组的末尾
          obj[paramName].push(paramValue);
        }
        // 如果指定了数组索引
        else {
          // 将值放在索引位置
          obj[paramName][paramNum] = paramValue;
        }
      }
      // 如果参数名不存在则设置它
      else {
        obj[paramName] = paramValue;
      }
    }
  }

  return obj;
};

const delQueStr = (url, ref) => {
  //删除参数值
  var str = '';

  if (url.indexOf('?') != -1) str = url.substr(url.indexOf('?') + 1);
  else return url;
  var arr = '';
  var returnurl = '';
  if (str.indexOf('&') != -1) {
    arr = str.split('&');
    for (let i in arr) {
      if (arr[i].split('=')[0] != ref) {
        returnurl = returnurl + arr[i].split('=')[0] + '=' + arr[i].split('=')[1] + '&';
      }
    }
    return url.substr(0, url.indexOf('?')) + '?' + returnurl.substr(0, returnurl.length - 1);
  } else {
    arr = str.split('=');
    if (arr[0] == ref) {
      return url.substr(0, url.indexOf('?'));
    } else {
      return url;
    }
  }
};

/**
 *
 * @param {string} url
 * @param {Array} arr 需要删除的参数，比如 ['code', 'msg', 'uuid', 'nickName', 'evidence']
 */
const removeUrlQuery = (url, arr) => {
  var newUrl = url;
  for (var i = 0; i < arr.length; i++) {
    newUrl = delQueStr(newUrl, arr[i]);
  }
  return newUrl;
};

export { baseUrl, system, systemIs, count, checkValidata, getNowData, projectApi, imgPath, threeNum, compareVersion, getAllUrlParams, removeUrlQuery };



// WEBPACK FOOTER //
// ./src/js/main.js